import React, { FunctionComponent } from 'react';
import { decode } from 'html-entities';

import { DashboardTile } from './dashboard-tile';
import { BulkManagementLink } from '../shared';

import './styles/bulk_management.scss';

interface DashboardProps {
  links: BulkManagementLink[];
}

export const Dashboard: FunctionComponent<DashboardProps> = (props) => {
  const { links } = props;
  return (
    <div className='manage-bulk-management' id='bulk-management-dashboard'>
      <h2>{`${decode(BFG.resource.name)} ${bfTranslate('Bulk Management')}`}</h2>
      <section className='bulk-management-tiles-container'>
        {links.map((link) => {
          if (link.href === 'dashboard') {
            return null;
          }
          return (
            <DashboardTile key={link.id} link={link} />
          );
        })}
      </section>
    </div>
  );
};
